import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import { Col, Table, Button, Clearfix } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { find as _find, findIndex as _findIndex } from 'lodash';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import WhiteLabelPluginEditData from 'components/layout/whiteLabel/WhiteLabelPluginEditData';
import WhiteLabelAddPlugin from 'components/layout/whiteLabel/WhiteLabelAddPlugin';
import IntlDateTime from 'components/layout/IntlDateTime';

import { ROLE_EMPLOYEE, ROLE_SUPERADMIN } from 'js/constants';
import may from 'js/security';

class WhiteLabelPlugins extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      shownId: null,
      showAddWhiteLabelPlugin: false,
    };
  }

  getTimezone = () => {
    const { defaultTimezone, timezone } = this.props;
    return timezone || defaultTimezone;
  };

  handleClick = pluginId => {
    const { user } = this.props;
    if (may(ROLE_SUPERADMIN, user.roles)) {
      this.setState(prevState => ({ shownId: pluginId === prevState.shownId ? null : pluginId }));
    }
  };

  showAddWhiteLabelPlugin = () => {
    const { user } = this.props;
    if (may(ROLE_SUPERADMIN, user.roles)) {
      this.setState({ showAddWhiteLabelPlugin: true, isActive: true });
    }
  };

  closeAddWhiteLabelPlugin = () => {
    this.setState({ showAddWhiteLabelPlugin: false, isActive: false });
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      appIntl,
      history,
      user,
      disabled,
    } = this.props;
    const { shownId, showAddWhiteLabelPlugin } = this.state;

    const columns = [messages.name, messages.status];
    let tBody = [];
    if (entityLoaded) {
      const plugins = entity.getPlugins();
      tBody = plugins.map((plugin, i) => {
        const { id, name, isActive, activationDate, freeUntil, terminationDate } = plugin;

        let status = '';

        if (isActive) {
          if (activationDate) {
            status = (
              <>
                {messages.active_since} <IntlDateTime date={activationDate} />
              </>
            );
          } else {
            status = messages.active;
          }
        } else {
          let intlDateTime = null;

          if (terminationDate || activationDate) {
            if (terminationDate) {
              intlDateTime = <IntlDateTime date={terminationDate} />;
            } else {
              intlDateTime = <IntlDateTime date={Date.now()} />;
            }

            status = (
              <>
                {messages.termination_date} {intlDateTime}
              </>
            );
          } else {
            status = (
              <>
                {messages.test_period_until} <IntlDateTime date={freeUntil} />
              </>
            );
          }
        }

        return (
          <tr
            key={id}
            class={(id === shownId ? 'shown ' : '') + (i % 2 ? 'even ' : 'odd ')}
            onClick={() => {
              this.handleClick(id);
            }}
          >
            <td class="v-align-middle semi-bold">{name}</td>
            <td class="v-align-middle">{status}</td>
          </tr>
        );
      });

      if (shownId !== null) {
        const pluginIndex = _findIndex(plugins, ['id', shownId]);
        const dataIndex = _findIndex(entity.getPlugins(), ['id', shownId]);
        const data = _find(entity.getPlugins(), ['id', shownId]);

        if (data) {
          tBody.splice(
            pluginIndex + 1,
            0,
            <WhiteLabelPluginEditData
              key={'details-showing-' + shownId}
              entityLoaded={entityLoaded}
              entity={entity}
              changeEntity={this.props.changeEntity}
              disabled={disabled}
              data={data}
              colSpan={columns.length}
              dataIndex={dataIndex}
            />
          );
        }
      }
    }

    return (
      <div>
        <Clearfix>
          {may(ROLE_EMPLOYEE, user.roles) && (
            <Col lg={4} class="m-t-15 pull-right">
              <Button
                block
                bsStyle="primary"
                onClick={() => history.push(appIntl.urlPrefix + 'account/settings/plugins/')}
              >
                <i className="fal fa-exclamation-circle" />
                <span className="hidden-xs hidden-sm m-l-10">{messages.navigate_to_plugins_and_configure}</span>
              </Button>
            </Col>
          )}
          {may(ROLE_SUPERADMIN, user.roles) && (
            <Col lg={3} class="m-t-15 pull-right">
              <Button block bsStyle="primary" onClick={this.showAddWhiteLabelPlugin} disabled={disabled}>
                <i className="fal fa-plus-circle" />
                <span className="hidden-xs hidden-sm m-l-10">Plugin hinzufügen</span>
              </Button>
            </Col>
          )}
        </Clearfix>
        <div class="clearfix padding-20 sm-padding-10">
          {entityLoaded && (
            <Table responsive hover class="table-detailed">
              <thead>
                <tr>
                  {columns.map((column, i) => {
                    return (
                      <th key={i} class={column === messages.actions ? 'text-right' : ''}>
                        {column}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <ReactCSSTransitionGroup
                transitionName="tablerows"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={1}
                component="tbody"
              >
                {tBody}
              </ReactCSSTransitionGroup>
            </Table>
          )}
        </div>

        <WhiteLabelAddPlugin
          show={showAddWhiteLabelPlugin}
          close={this.closeAddWhiteLabelPlugin}
          key="filled-questionnaire-new-popup"
          disabled={disabled}
          whiteLabelProject={entity}
          entity={entity}
        />
      </div>
    );
  }
}
WhiteLabelPlugins.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    locale: state.intl.locale,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(WhiteLabelPlugins)));
